module.exports = __webpack_public_path__ + "static/media/scam.c581731e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/scam.jpg
// module id = 372
// module chunks = 0